import { redirect } from "react-router-dom";
import CheckToken from "../../services/CheckToken";

export default async function checkAuthenticated(setCheckLogin) {
  try {
    const isAuthenticated = await CheckToken();

    if (isAuthenticated) {
      setCheckLogin(true);
      return null;
    }
    throw new Error();
  } catch {
    setCheckLogin(false);
    localStorage.clear();
    return redirect("/login");
  }
}
